import { supabase } from './supabaseClient';
import { convertToWebp } from './imageUtils';

const MAX_SIZE_BYTES = 5 * 1024 * 1024;
const ALLOWED_TYPES = ['image/png', 'image/jpeg', 'image/webp', 'image/gif'];
const MAX_DIMENSION = 512; // avatars only ever render small — no need to keep original resolution

export async function uploadAvatar(userId: string, file: File): Promise<string> {
  if (!ALLOWED_TYPES.includes(file.type)) {
    throw new Error('Please choose a PNG, JPEG, WEBP, or GIF image.');
  }
  if (file.size > MAX_SIZE_BYTES) {
    throw new Error('Image must be smaller than 5MB.');
  }

  const webp = await convertToWebp(file, MAX_DIMENSION);
  const path = `${userId}/avatar.webp`;

  const { error: uploadError } = await supabase.storage.from('avatars').upload(path, webp, {
    upsert: true,
    contentType: 'image/webp',
  });
  if (uploadError) throw uploadError;

  const {
    data: { publicUrl },
  } = supabase.storage.from('avatars').getPublicUrl(path);

  // Cache-bust so the new image shows immediately even though the path is stable.
  const versionedUrl = `${publicUrl}?v=${Date.now()}`;

  const { error: updateError } = await supabase.auth.updateUser({ data: { avatar_url: versionedUrl } });
  if (updateError) throw updateError;

  return versionedUrl;
}
